// mcq options match by `value`, so shuffled options stay aligned.
const mergeOptions = (englishOptions, translatedOptions) => {
  const labelByValue = new Map((translatedOptions || []).map((o) => [o.value, o.label]));
  return englishOptions.map((option) =>
    labelByValue.has(option.value) ? { ...option, label: labelByValue.get(option.value) } : option
  );
};

export const mergeMcq = (jsonData, translated) => ({
  ...jsonData,
  stimulus: translated.stimulus ?? jsonData.stimulus,
  options: mergeOptions(jsonData.options || [], translated.options),
});
